/**
 * RoleSwitchModal - Confirmation dialog for role switching
 *
 * Displays a warning when user tries to login as a different role
 * Requires explicit confirmation before clearing current session
 */

import React from 'react';

const RoleSwitchModal = ({ currentRole, targetRole, onConfirm, onCancel }) => {
  return (
    <div
      className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-start sm:items-center justify-center z-[100] px-6 overflow-y-auto"
      style={{
        paddingTop: 'calc(env(safe-area-inset-top, 0px) + 1rem)',
        paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 1rem)'
      }}
    >
      <div className="bg-[#0a0a0f] border border-yellow-400/30 rounded-2xl p-8 max-w-md w-full my-auto max-h-[calc(100dvh-env(safe-area-inset-top,0px)-env(safe-area-inset-bottom,0px)-2rem)] overflow-y-auto shadow-2xl">
        {/* Warning Icon */}
        <div className="flex justify-center mb-6">
          <div className="h-16 w-16 bg-yellow-500/20 rounded-full flex items-center justify-center">
            <svg
              className="w-10 h-10 text-yellow-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4 text-center">
          Role Switch Detected
        </h2>

        {/* Message */}
        <div className="mb-6 p-4 bg-yellow-500/10 border border-yellow-500/30 rounded-lg">
          <p className="text-gray-300 text-center mb-3">
            You are currently logged in as{' '}
            <span className="text-yellow-400 font-semibold">{currentRole}</span>.
          </p>
          <p className="text-gray-300 text-center">
            Switching to{' '}
            <span className="text-[#3E7BFA] font-semibold">{targetRole}</span>{' '}
            will log you out from your current session.
          </p>
        </div>

        <p className="text-gray-400 text-sm text-center mb-6">
          Do you want to continue?
        </p>

        {/* Actions */}
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 bg-white/5 border border-white/10 px-6 py-3 rounded-lg text-gray-300 hover:bg-white/10 transition"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-3 rounded-lg bg-[#0A2472] hover:bg-[#0d2d8a] text-white font-semibold transition shadow-lg"
          >
            Switch Role
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoleSwitchModal;
